import promise from 'bluebird';
import {reportsService} from "../_services";
import {ResponseFilter} from "../config/response-handler";

export const reportsActions = {
    getReasons,
    getReportedUsers,
    getReportedDishes,
    getAddress,
    acceptReportedDish,
    rejectReportedDish,
};
export const reportsConstants = {

    GET_REASONS_REQUEST: 'GET_REASONS_REQUEST',
    GET_REASONS_SUCCESS: 'GET_REASONS_SUCCESS',
    GET_REASONS_ERROR: 'GET_REASONS_ERROR',

    GET_REPORTED_USERS_REQUEST: 'GET_REPORTED_USERS_REQUEST',
    GET_REPORTED_USERS_SUCCESS: 'GET_REPORTED_USERS_SUCCESS',
    GET_REPORTED_USERS_ERROR: 'GET_REPORTED_USERS_ERROR',

    GET_REPORTED_DISHES_REQUEST: 'GET_REPORTED_DISHES_REQUEST',
    GET_REPORTED_DISHES_SUCCESS: 'GET_REPORTED_DISHES_SUCCESS',
    GET_REPORTED_DISHES_ERROR: 'GET_REPORTED_DISHES_ERROR',

    GET_ADDRESS_REQUEST: 'GET_ADDRESS_REQUEST',
    GET_ADDRESS_SUCCESS: 'GET_ADDRESS_SUCCESS',
    GET_ADDRESS_ERROR: 'GET_ADDRESS_ERROR',

    ACCEPT_REPORTED_DISH_REQUEST: 'ACCEPT_REPORTED_DISH_REQUEST',
    ACCEPT_REPORTED_DISH_SUCCESS: 'ACCEPT_REPORTED_DISH_SUCCESS',
    ACCEPT_REPORTED_DISH_ERROR: 'ACCEPT_REPORTED_DISH_ERROR',

    REJECT_REPORTED_DISH_REQUEST: 'REJECT_REPORTED_DISH_REQUEST',
    REJECT_REPORTED_DISH_SUCCESS: 'REJECT_REPORTED_DISH_SUCCESS',
    REJECT_REPORTED_DISH_ERROR: 'REJECT_REPORTED_DISH_ERROR',

}


function getAddress(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.getAddress(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(getAddressRequest) {
        return {type: reportsConstants.GET_ADDRESS_REQUEST, getAddressRequest}
    }

    function success(getAddressSuccess) {
        return {type: reportsConstants.GET_ADDRESS_SUCCESS, getAddressSuccess}
    }

    function failure(getAddressFail) {
        return {type: reportsConstants.GET_ADDRESS_ERROR, getAddressFail}
    }
}
function getReasons(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.getReasons(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(getReasonsRequest) {
        return {type: reportsConstants.GET_REASONS_REQUEST, getReasonsRequest}
    }

    function success(getReasonsSuccess) {
        return {type: reportsConstants.GET_REASONS_SUCCESS, getReasonsSuccess}
    }

    function failure(getReasonsFail) {
        return {type: reportsConstants.GET_REASONS_ERROR, getReasonsFail}
    }
}
function getReportedUsers(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.getReportedUsers(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(getReportedUsersRequest) {
        return {type: reportsConstants.GET_REPORTED_USERS_REQUEST, getReportedUsersRequest}
    }

    function success(getReportedUsersSuccess) {
        return {type: reportsConstants.GET_REPORTED_USERS_SUCCESS, getReportedUsersSuccess}
    }

    function failure(getReportedUsersFail) {
        return {type: reportsConstants.GET_REPORTED_USERS_ERROR, getReportedUsersFail}
    }
}

function getReportedDishes(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.getReportedDishes(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(getReportedDishesRequest) {
        return {type: reportsConstants.GET_REPORTED_DISHES_REQUEST, getReportedDishesRequest}
    }

    function success(getReportedDishesSuccess) {
        return {type: reportsConstants.GET_REPORTED_DISHES_SUCCESS, getReportedDishesSuccess}
    }

    function failure(getReportedDishesFail) {
        return {type: reportsConstants.GET_REPORTED_DISHES_ERROR, getReportedDishesFail}
    }
}

function acceptReportedDish(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.acceptReportedDish(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(acceptReportedDishRequest) {
        return {type: reportsConstants.ACCEPT_REPORTED_DISH_REQUEST, acceptReportedDishRequest}
    }

    function success(acceptReportedDishSuccess) {
        return {type: reportsConstants.ACCEPT_REPORTED_DISH_SUCCESS, acceptReportedDishSuccess}
    }

    function failure(acceptReportedDishFail) {
        return {type: reportsConstants.ACCEPT_REPORTED_DISH_ERROR, acceptReportedDishFail}
    }
}

function rejectReportedDish(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            reportsService.rejectReportedDish(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(rejectReportedDishRequest) {
        return {type: reportsConstants.REJECT_REPORTED_DISH_REQUEST, rejectReportedDishRequest}
    }

    function success(rejectReportedDishSuccess) {
        return {type: reportsConstants.REJECT_REPORTED_DISH_SUCCESS, rejectReportedDishSuccess}
    }

    function failure(rejectReportedDishFail) {
        return {type: reportsConstants.REJECT_REPORTED_DISH_ERROR, rejectReportedDishFail}
    }
}

